import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { RewardPointCSSStyleImpl } from './rewardpointcss';
import { RewardPointViewImpl } from './rewardpointview';
import { RewardPointDto } from 'src/com/sixdee/crbtportal/core/dto/rewardpoint/rewardpointdto';

export interface RewardPointComponentProps extends UIComponentProps
{
    headerTitle: string;
    id:string;
    rewardPointDto:RewardPointDto;
    closePopup(): void;
}

export interface RewardPointComponentHandler extends UIComponentHandler
{
    closePopup(): void;
}

export class RewardPointComponent extends UIComponentImpl<RewardPointComponentProps, UIComponentState, UIDataModel> 
implements RewardPointComponentHandler
{
    constructor(props: RewardPointComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new RewardPointViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new RewardPointCSSStyleImpl(applicationContext);
    }

    closePopup():void
    {
        this.props.closePopup();
    }
   
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/rewardpoint/rewardpointcomponent.tsx